import Store from "./Store";
import axios from "axios";
import Message from "./Message";

/**
 * 商品一覧制御用のjsonをストアし、管理するクラス
 * 基幹システムで取り扱いのない情報は/web/products/index.jsonで管理する
 */
export default class Products{
  constructor() {
    this.store = new Store();
  }

  loadProducts() {
    this.store.set("products", "{}");
    axios.get(process.env.VUE_APP_CONTENTS_PRODUCT_HOME + "index.json?"+new Date().getTime())
    .then(res => {
      this.store.set("products", JSON.stringify(res.data.products));
      this.store.set("productOrders", JSON.stringify(res.data.orders));
      this.store.set("productCategories", JSON.stringify(res.data.categories));
    }).catch(error => {
      Message.create().error({
        title: "アプリケーションの初期化に失敗しました",
        text: error
      });
    });
  }

  getProducts() {
    return JSON.parse(this.store.get("products"));
  }

  getProduct(productNo) {
    let products = this.getProducts();
    return products[productNo];
  }

  getCategories() {
    return JSON.parse(this.store.get("productCategories"));
  }

  getCategoryItems(category) {
    let orders = JSON.parse(this.store.get("productOrders"));
    return orders[category];
  }

}
